/** Katarina AbilitySpec seed kit (wiki-aligned numeric batch 3). */
export const KATARINA_ABILITY_DEFS = [
  {
    id: 'katarina_q',
    champKey: 'katarina',
    slot: 'Q',
    name: 'Bouncing Blade',
    targeting: 'targeted',
    range: 625,
    castTime: 0.25,
    travelSpeed: 1600,
    width: null,
    radius: 375,
    cooldown: 11,
    manaCost: 0,
    costType: 'none',
    vfxId: 'katarina_q',
    status: 'wired'
  },
  {
    id: 'katarina_w',
    champKey: 'katarina',
    slot: 'W',
    name: 'Preparation',
    targeting: 'self_buff',
    range: 0,
    castTime: 0,
    travelSpeed: null,
    width: null,
    radius: null,
    cooldown: 15,
    manaCost: 0,
    costType: 'none',
    vfxId: 'katarina_w',
    status: 'wired'
  },
  {
    id: 'katarina_e',
    champKey: 'katarina',
    slot: 'E',
    name: 'Shunpo',
    targeting: 'blink',
    range: 725,
    castTime: 0.15,
    travelSpeed: null,
    width: null,
    radius: null,
    cooldown: 12,
    manaCost: 0,
    costType: 'none',
    vfxId: 'katarina_e',
    status: 'wired'
  },
  {
    id: 'katarina_r',
    champKey: 'katarina',
    slot: 'R',
    name: 'Death Lotus',
    targeting: 'aoe_self',
    range: 550,
    castTime: 0,
    travelSpeed: null,
    width: null,
    radius: 550,
    cooldown: 75,
    duration: 2.5,
    travelSpeed: 2400,
    manaCost: 0,
    costType: 'none',
    vfxId: 'katarina_r',
    status: 'wired'
  }
];
